import * as a from '#editors/html/attribute'

export function on(name: string, value: (event: Event) => void): a.Attribute {
  return { name, value, kind: 'handler' }
}

export const onClick = (value: (event: Event) => void) => on('click', value)
